import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ServiceLeadForm } from '@/components/ServiceLeadForm';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Mail, Phone, MapPin } from 'lucide-react';

export const ContactPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <section className="py-10 sm:py-16 md:py-20">
        <div className="mx-auto w-full max-w-[var(--container)] px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              Contactez-nous
            </h1>
            <p className="text-sm sm:text-base md:text-lg text-muted-foreground max-w-2xl mx-auto px-2">
              Une question ? Un projet ? Remplissez le formulaire ci-dessous, nous vous répondons sous 24h.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            {/* Contact Info */}
            <div className="space-y-3 sm:space-y-4 md:space-y-6 order-2 lg:order-1">
              <Card>
                <CardHeader className="pb-2 sm:pb-4">
                  <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
                    <Mail className="h-4 w-4 sm:h-5 sm:w-5" />
                    Email
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <a href="mailto:contact@homely-solutions.ch" className="text-primary hover:underline text-sm sm:text-base break-all">
                    contact@homely-solutions.ch
                  </a>
                </CardContent>
              </Card>

              <Card>
                <CardHeader className="pb-2 sm:pb-4">
                  <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
                    <MapPin className="h-4 w-4 sm:h-5 sm:w-5" />
                    Adresse
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <p className="text-xs sm:text-sm text-muted-foreground">
                    <strong>Homely Solutions Sàrl</strong><br />
                    Rue Jean-André Venel 4<br />
                    1400 Yverdon-les-Bains
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader className="pb-2 sm:pb-4">
                  <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
                    <MapPin className="h-4 w-4 sm:h-5 sm:w-5" />
                    Zones d'intervention
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <p className="text-xs sm:text-sm text-muted-foreground">
                    Genève, Lausanne, Montreux, Verbier, Crans-Montana, Villars, Fribourg, Neuchâtel, Valais
                  </p>
                </CardContent>
              </Card>
            </div>

            {/* Form */}
            <div className="lg:col-span-2 order-1 lg:order-2">
              <ServiceLeadForm 
                service="contact" 
                pole="general" 
                questions={[
                  { id: 'sujet', label: 'Sujet de votre demande', type: 'select', options: ['Nettoyage', 'Conciergerie', 'Rénovation', 'Marketing', 'Immobilier', 'Autre'] }
                ]} 
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};